export const PREFERRED_NAME_EXTENSION_URL = 'http://polarissleep.com/preferred-name';
